// extracted by mini-css-extract-plugin
export default {"default":"RjF99PhFjQbwWYBihvWT","secundary":"wJdGVhP6ctyUjklmNaI9","primary":"_ksl72CcpSsUfdeC2mGX","primary-invert":"boswzWfOReyOoMgGJ4Os"};